export default __webpack_public_path__ + "static/media/letterbox-outline-16px.5089ae27.svg";